class SearchHeaderPanel extends HTMLElement {
  connectedCallback() {
    this._onDocumentClick = this._onDocumentClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);

    document.addEventListener('click', this._onDocumentClick);
    document.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocumentClick);
    document.removeEventListener('keydown', this._onKeydown);
    this._setBodyLock(false);
  }

  get isOpen() {
    return this.hasAttribute('open');
  }

  get input() {
    return this.querySelector('#search-drawer-input');
  }

  get header() {
    return document.querySelector('.header');
  }

  open() {
    if (this.isOpen) return;

    this.setAttribute('open', '');
    this._setBodyLock(true);

    if (this.header) {
      this.header.classList.add('is-solid');
    }

    window.requestAnimationFrame(() => {
      if (this.input) this.input.focus();
    });
  }

  close() {
    if (!this.isOpen) return;

    this.removeAttribute('open');
    this._setBodyLock(false);

    if (this.header) {
      this.header.classList.remove('is-solid');
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  _onDocumentClick(event) {
    const activator = event.target.closest(`[aria-controls="${this.id}"]`);

    if (activator) {
      event.preventDefault();
      this.toggle();
      return;
    }

    if (this.isOpen && event.target.closest('[data-search-close]')) {
      event.preventDefault();
      this.close();
    }
  }

  _onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
    }
  }

  _setBodyLock(locked) {
    document.documentElement.classList.toggle('search-header-open', locked);
  }
}

if (!window.customElements.get('search-header-panel')) {
  window.customElements.define('search-header-panel', SearchHeaderPanel);
}